<template>
  <IconLucideSettings />
</template>
